import { defineComponent as r } from "vue";
import { useLoadingBar as n } from "./ghl-ui.es702.js";
const g = r({
  setup() {
    const o = n();
    return {
      startLoading: () => {
        o.start();
      },
      finishLoading: () => {
        o.finish();
      },
      errorLoading: () => {
        o.error();
      }
    };
  }
});
export {
  g as loadingBarTrigger
};
